import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import SideMenuContext from "./../../common/context/sideMenuContext";
import { loadImage } from "./../../common/services/uiService";
import SideBarMapi from "./fields/sidebar";
import "./../../common/styles/navbar.css";
import {BrowserView, MobileView,isBrowser,isMobile} from 'react-device-detect';
import { AuthContext, useAuth} from './../contexts/AuthContext'; 



const NavBar = () => {
  const { userData, isAuthenticated, logout } = useAuth();
  const user = userData ? userData.user.displayName : "";

  const userProfilePic = loadImage("UserProfilePic.svg");
  const logo1 = loadImage("logo_Anambra.png");
  const logo2 = loadImage("logo_Anambra.png");
  const logo3 = loadImage("logo_Anambra.png");

  const handleLogout = () => {
    logout();
    window.location.href = window.location.origin + "/home";
  };

  return (
    <React.Fragment>
      <div
        id="MainLeftNavDiv"
      >

        {isAuthenticated && user && (
          <div id="LeftMenuUser">
              <div id="HelloUserDiv">
                <span className="LeftHelloUser">{user}</span>
              </div>
              {/* <div className="userProfileDiv">
                <button
                  className="userProfilePicLink tooltip"
                  onClick={handleLogout}
                >
                  <img
                    src={userProfilePic}
                    className="userProfilePic"
                    alt="User Profile"
                  />
                  <div className="tooltiptext">Log out</div>
                </button>
              </div> */}
          </div>
        )}

        {/* Desktop title */}
        <div id="Mapi3DServices" className="MapiFullTitle">
            <span>המרכז למיפוי ישראל</span>
            <span className="separatorDiv"> | </span>
            <span>בנק"ל תלת ממדי</span>
          </div>

        {/* Mobile and tablet title */}  
          <div id="Mapi_TITLE" className="MapiShortTitle">
            <span>מפ"י</span>
          </div>

      </div>
    </React.Fragment>
  );
};

export default NavBar;
